import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './scss/global.scss';
import * as Sentry from '@sentry/react';
import pkjJson from '../package.json';
import ignoreErrors from './utils/sentry/sentry-ignore-errors';
import { SENTRY_ERROR_CAPTURE_STRING } from './utils/sentry/sentry-utils';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: pkjJson.version,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
      networkDetailAllowUrls: [
        process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL ?? '',
        process.env.REACT_APP_X_SHOPIFY_GRAPHQL_URL ?? '',
      ],
    }),
    Sentry.browserProfilingIntegration(),
  ],
  environment: process.env.REACT_APP_ENV,
  tracesSampleRate: 0.1,
  profilesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors,
  beforeSend: (event, hint) => {
    if (
      event.request?.url?.includes('localhost') ||
      event.request?.url?.includes('dev')
    ) {
      return null;
    }
    // Remove the hard coded capture prefix message
    if (typeof event.message === 'string') {
      event.message = event.message.replace(SENTRY_ERROR_CAPTURE_STRING, '');
    }
    if (typeof hint.originalException === 'string') {
      hint.originalException = hint.originalException.replace(
        SENTRY_ERROR_CAPTURE_STRING,
        '',
      );
    }

    const stacktrace = event.exception?.values?.[0]?.stacktrace?.frames || [];

    // Matching stack trace to identify third party errors
    const isThirdPartyError = stacktrace.some(
      (frame) =>
        frame.filename &&
        (frame.filename.includes('node_modules') ||
          frame.filename.includes('vendor')),
    );

    // Skipping, Thired party library errors
    if (isThirdPartyError) {
      return null;
    }

    return event;
  },
  beforeSendTransaction(event) {
    if (
      event.request?.url?.includes('localhost') ||
      event.request?.url?.includes('dev')
    ) {
      return null;
    }
    return event;
  },
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function`
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
